import { ConsentBanner, CustomLinkProps } from '@ifixit/consent-banner';
import { ShopifyConfig } from '@ifixit/consent-banner/shopify-consent';
import { cn } from '@ifixit/ui/lib/utils';
import initializeComponent from 'Shared/react-initialize';
import { PropsWithChildren } from 'react';

function CarpenterConsentComponent({
   isTest,
   flagEnabled,
   privacyPolicyUrl = '/Info/Privacy',
   piwikSiteId,
   needsConsent,
   gpcEnabled,
   shopifyConfig,
}: {
   isTest: boolean;
   flagEnabled: boolean;
   privacyPolicyUrl?: string;
   piwikSiteId: string;
   needsConsent: boolean;
   gpcEnabled: boolean;
   shopifyConfig: ShopifyConfig;
}) {
   if (isTest && !flagEnabled) {
      return null;
   }

   // eslint-disable-next-line @eslint-react/no-nested-component-definitions -- TODO: grandfathered in eslint-plugin-react -> @eslint-react migration
   const CustomLink = ({ children, href, className }: PropsWithChildren<CustomLinkProps>) => (
      <a href={href} className={cn('underline', className)}>
         {children}
      </a>
   );

   return (
      <ConsentBanner
         CustomLink={CustomLink}
         privacyPolicyUrl={privacyPolicyUrl}
         needsConsent={needsConsent}
         gpcEnabled={gpcEnabled}
         piwikSiteId={piwikSiteId}
         shopifyConfig={shopifyConfig}
      />
   );
}

initializeComponent('ConsentBanner', CarpenterConsentComponent);
